var _path, _g, _path2, _g2, _path3, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoogleAds = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 65,
  height: 32,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#google-ads_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "google-ads_svg__b",
  width: 25,
  height: 31,
  x: 3,
  y: 4,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.962 4.755h23.592v29.413H3.962z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-ads_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3C8BD9",
  d: "M12.039 7.445c.226-.593.536-1.138.997-1.58 1.843-1.796 4.89-1.345 6.14.912.94 1.711 1.937 3.385 2.905 5.078l4.852 8.444c1.345 2.36-.113 5.34-2.783 5.745-1.636.244-3.169-.508-4.015-1.975l-4.27-7.41a1 1 0 0 0-.103-.15c-.15-.122-.216-.3-.31-.46l-3.14-5.445a3.9 3.9 0 0 1-.518-2.069c.029-.376.076-.752.245-1.09"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FABC04",
  d: "M12.04 7.445a5.4 5.4 0 0 0-.18 1.034c-.027.79.17 1.523.565 2.21l3.094 5.35c.094.16.169.32.263.47l-1.702 2.925-2.379 4.1c-.038 0-.047-.02-.056-.048-.01-.075.018-.14.037-.216.386-1.41.066-2.661-.902-3.733-.593-.649-1.345-1.015-2.21-1.138-1.129-.16-2.125.132-3.019.837-.16.122-.263.301-.451.395-.038 0-.056-.019-.066-.047l1.345-2.341 5.595-9.695c.018-.038.047-.066.066-.103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A852",
  d: "m5.071 19.612.536-.48c2.285-1.805 5.718-.498 6.216 2.36.122.687.056 1.345-.15 2.004a1 1 0 0 1-.038.16c-.085.15-.16.31-.254.46-.837 1.383-2.069 2.069-3.686 1.965-1.852-.131-3.31-1.523-3.564-3.366a3.76 3.76 0 0 1 .517-2.501c.094-.17.207-.32.31-.489.048-.038.029-.113.113-.113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FABC04",
  d: "M5.072 19.612c-.038.038-.038.104-.104.113-.01-.066.028-.103.066-.15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E1C025",
  d: "M11.635 23.656c-.038-.066 0-.113.037-.16l.038.037z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "google-ads_svg__c",
  width: 55,
  height: 67,
  x: 26,
  y: -49,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26.762-48.966h53.603v66.828H26.762z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-ads_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M31.184 6.667c-2.414 0-4.422 1.944-4.422 4.337s2.008 4.315 4.422 4.315c1.303 0 2.265-.427 3.034-1.218.79-.79 1.025-1.88 1.025-2.756 0-.277-.021-.534-.064-.747h-3.995v1.175h2.842c-.086.662-.3 1.153-.641 1.495-.406.406-1.069.876-2.2.876-1.753 0-3.12-1.41-3.12-3.14s1.367-3.14 3.12-3.14c.94 0 1.644.362 2.136.854l.833-.834c-.705-.683-1.645-1.217-2.97-1.217m7.243 3.098c-1.517 0-2.778 1.175-2.778 2.82 0 1.623 1.24 2.82 2.778 2.82s2.777-1.197 2.777-2.82c0-1.624-1.26-2.82-2.777-2.82m0 4.529c-.834 0-1.56-.705-1.56-1.71 0-1.003.727-1.708 1.56-1.708s1.56.683 1.56 1.709c0 1.004-.727 1.709-1.56 1.709m6.025-4.53c-1.539 0-2.778 1.176-2.778 2.82 0 1.624 1.24 2.82 2.778 2.82 1.516 0 2.777-1.196 2.777-2.82s-1.24-2.82-2.777-2.82m0 4.53c-.834 0-1.56-.705-1.56-1.71 0-1.003.726-1.708 1.56-1.708.833 0 1.56.683 1.56 1.709 0 1.004-.706 1.709-1.56 1.709m6.003-4.53c-1.389 0-2.65 1.218-2.65 2.8 0 1.559 1.261 2.777 2.65 2.777.662 0 1.175-.3 1.453-.641h.042v.406c0 1.068-.555 1.645-1.474 1.645-.748 0-1.196-.534-1.389-.983l-1.068.449c.3.747 1.111 1.645 2.457 1.645 1.432 0 2.628-.855 2.628-2.906v-5H51.95v.45h-.042c-.278-.342-.79-.642-1.453-.642m.107 4.487c-.834 0-1.538-.705-1.538-1.688 0-.982.704-1.709 1.538-1.709.833 0 1.474.727 1.474 1.71 0 .982-.641 1.687-1.474 1.687m3.44-7.243h1.217v8.247h-1.218zm4.486 2.757c-1.453 0-2.67 1.132-2.67 2.82 0 1.58 1.196 2.82 2.798 2.82 1.303 0 2.051-.79 2.35-1.24l-.961-.64c-.32.47-.77.769-1.389.769-.64 0-1.09-.278-1.367-.855l3.781-1.56-.128-.32c-.235-.62-.961-1.794-2.414-1.794m-1.453 2.734a1.547 1.547 0 0 1 1.474-1.645c.492 0 .919.235 1.047.598z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "google-ads_svg__d",
  width: 54,
  height: 67,
  x: -2,
  y: -39,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-1.607-38.93h53.603v66.827H-1.607z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-ads_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "m34.798 25.162 2.82-7.498h1.09l2.82 7.498h-1.069l-.726-2.03h-3.14l-.727 2.03zm2.115-2.927h2.5l-1.218-3.375h-.043zm5.597 2.308c-.47-.534-.705-1.175-.705-1.944 0-.748.235-1.389.705-1.945.492-.534 1.047-.79 1.73-.79.386 0 .727.085 1.026.235.32.17.556.363.727.641h.042l-.042-.705v-2.372h.961v7.5h-.919v-.706h-.042c-.171.257-.406.47-.727.641s-.662.235-1.025.235c-.684 0-1.26-.256-1.73-.79m3.034-.598c.32-.342.47-.79.47-1.346 0-.534-.15-.983-.47-1.325a1.46 1.46 0 0 0-1.153-.513q-.705 0-1.154.513c-.32.342-.47.79-.47 1.325s.15.982.47 1.324q.48.513 1.154.513c.47.021.854-.15 1.153-.491m5.854.918c-.385.3-.876.47-1.474.47-.513 0-.962-.128-1.367-.406a2.3 2.3 0 0 1-.834-1.068l.855-.363c.128.3.299.555.555.726.235.171.513.257.79.257q.45 0 .77-.192c.214-.129.3-.3.3-.47 0-.321-.257-.577-.749-.727l-.876-.214c-1.004-.256-1.495-.726-1.495-1.452 0-.47.192-.834.577-1.133.384-.277.876-.427 1.453-.427.433-.003.86.108 1.239.32.363.214.62.513.769.876l-.855.364a1.2 1.2 0 0 0-.47-.513 1.44 1.44 0 0 0-.748-.192c-.256 0-.47.064-.683.192-.193.128-.3.278-.3.47 0 .299.278.513.834.62l.769.192c1.026.256 1.517.769 1.517 1.538.021.449-.192.833-.577 1.132"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "google-ads_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.032 0h64v32h-64z"
})))));
export default SvgGoogleAds;